<template>
  <div class="home">
    <div
      class="banner"
      :style="pcBanner ? `background-image: url(${pcBanner.image})` : ''"
      @click="goAd(pcBanner)"
    >
      <div class="banner-content" @click.stop>
        <div class="live">
          <div class="living">
            <dj-video
              :playSrc="playSrc"
              :playSrcChange="playSrcChange"
              :autoplay="true"
              :isLive="true"
              ref="djvideo"
              :homeLive="true"
              :liveUid="liveUid"
              :liveStream="liveStream"
            ></dj-video>
          </div>
        </div>
        <div class="live-list">
          <div
            class="live-li"
            :class="{ 'living-active': index === liveIndex }"
            v-for="(live, index) in liveList"
            :key="live.uid"
            @click="clickLiveList(index, live.uid, live.stream, live)"
          >
            <img v-lazy="live.thumb" alt="logo" />
            <div class="show-title">{{ live.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="game-list" v-show="HotData.length > 0">
      <div class="game-lunbo">
        <div
          class="swiper-container swiper-container-initialized swiper-container-horizontal"
        >
          <swiper class="swiper-wrapper" :options="swiperOption">
            <swiperSlide
              class="swiper-slide"
              v-for="(item, index) in HotData"
              :key="index"
              @click.native="toMatchDetail(item)"
            >
              <div class="slide-top">
                <div
                  class="slide-left"
                  :class="{ isplaying: item.is_playing === 1 }"
                >
                  {{ item.name }}
                </div>
                <div
                  class="slide-right"
                  :class="[{ isplaying: item.is_playing == '1' }]"
                >
                  {{ item.statusName }}
                </div>
              </div>
              <div
                class="slide-bottom"
                :class="{ matching: item.is_playing === 1 }"
              >
                <div class="game-name">
                  <img v-lazy="item.home_icon" alt="logo" />
                </div>
                <div class="game-name">
                  <img v-lazy="item.away_icon" alt="logo" />
                </div>
              </div>
              <div class="slide-bottom">
                <div class="game-name">{{ item.home_team }}</div>
                <div>
                  <span class="vs">VS</span>
                </div>
                <div class="game-name">{{ item.away_team }}</div>
              </div>
              <div class="slide-bottom">
                <div class="game-date">{{ item.start_time_name }}</div>
                <!-- <div class="game-date" v-else>
                  <span class="socre" :class="{isplaying :item.is_playing === '1'}">{{item.home_scores || 0}}</span>
                  <span class="socre" :class="{isplaying :item.is_playing === '1'}">{{item.away_scores || 0}}</span>
                </div> -->
              </div>
              <div class="slide-bottom type-bottom">
                <div class="playing" v-if="item.is_playing === 1">
                  <img src="../assets/img/Vector.png" alt="" />
                  {{ $t("home.living") }}
                </div>
                <div class="unplay" v-else>
                  {{
                    item.is_playing === 0
                      ? $t("home.book_now")
                      : $t("home.ended")
                  }}
                </div>
              </div>
            </swiperSlide>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div>
      </div>
    </div>
    <div class="section-bottom">
      <div class="ad-middle">
        <el-cascader height="100%" indicator-position="none" class="ad-live">
          <el-cascader-item v-for="(banner, index) in adList" :key="index">
            <div
              class="ad-bg"
              :style="{ backgroundImage: `url(${banner.image})` }"
              @click="goAd(banner)"
            ></div>
          </el-cascader-item>
        </el-cascader>
        <div class="announcement">
          <div class="announcement-icon">
            <i class="iconfont laba">&#xe602;</i>{{ $t("home.announcement") }}
          </div>
          <div
            class="announcement-words"
            v-for="item in bulletinData"
            :key="item.id"
            @click="goAnnouncement(item)"
          >
            <div class="words-left">
              <i class="iconfont dian">&#xe7a5;</i>
              {{ item.title }}
            </div>
            <div class="words-right">{{ getDate(item.addtime) }}</div>
          </div>
        </div>
        <div class="download-app">
          <el-cascader height="100%" indicator-position="none" class="ad-live">
            <el-cascader-item
              v-for="(banner, index) in rightAdList"
              :key="index"
            >
              <div
                class="ad-bg"
                :style="{ backgroundImage: `url(${banner.image})` }"
                @click="goAd(banner)"
              ></div>
            </el-cascader-item>
          </el-cascader>
        </div>
      </div>
      <introduce-live :isHome="true"></introduce-live>
      <div class="Recommend-list" v-if="RecommendData.length > 0">
        <div class="intro-top">
          <div class="live-icon">
            <i class="iconfont living-icon">&#xe60b;</i>&ensp;{{
              $t("home.match_recommend")
            }}
          </div>
        </div>
        <div class="intro-bottom">
          <div
            class="intro-list"
            v-for="item in RecommendData"
            :key="item.uid"
            @click="keepLivePull(item)"
          >
            <div class="introlist-top">
              <img v-lazy="item.thumb" :alt="$t('home.icon_alt')" />
              <div class="hover-play">
                <span></span>
              </div>
            </div>
            <div class="introlist-bottom">
              <div class="introlist-words">
                {{ item.title }}
              </div>
              <div class="introlist-look">
                <div class="look-left">
                  <img
                    v-lazy="item.avatar_thumb || item.user.avatar_thumb"
                    :alt="$t('home.icon_alt')"
                  />&ensp;{{ item.user_nicename || item.user.user_nicename }}
                </div>
                <div class="look-right">
                  <i class="iconfont look-time">&#xe607;</i>&ensp;{{
                    item.viewnum || item.user.viewnum
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const dayjs = require("dayjs");
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import introduceLive from "./../base/introduceLive";
import djVideo from "./../base/video";
import { Carousel, CarouselItem } from "element-ui";
import { apiGetHot, apiGetAdList, apiClickAd, sportgetHomeData } from "../http";
export default {
  name: "home",
  components: {
    swiper,
    swiperSlide,
    introduceLive,
    djVideo,
    "el-cascader": Carousel,
    "el-cascader-item": CarouselItem,
  },
  data() {
    return {
      liveUid: "", //直播的uid
      liveStream: "", //直播的stream
      playSrc: "",
      playSrcChange: false,
      bulletinData: [],
      HotData: [],
      liveList: [],
      realLiveList: [],
      adList: [],
      rightAdList: [],
      liveIndex: 0,
      swiperOption: {
        slidesPerView: 5, // 每页展示几个
        slidesPerGroup: 5, // 每屏滚动几个
        loopFillGroupWithBlank: true,
        //循环
        // loop:true,
        //每张播放时长3秒，自动播放
        autoplay: false,
        //滑动速度
        speed: 200,
        spaceBetween: 12,
        pagination: ".swiper-pagination",
        // delay:1000
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
      },
      pcBanner: null,
      playerClickCount: 0,
      RecommendData: [],
      liveListMore: [],
    };
  },
  computed: {
    activeLive() {
      if (this.liveList.length > 0) {
        //如果有直播数据才存储拉流地址
        localStorage.setItem("pull", this.liveList[this.liveIndex].pull);
      }
      return this.liveList[this.liveIndex];
    },
    homeConfig() {
      return this.$store.state.config;
    },
  },
  watch: {
    activeLive(val) {
      if (val) {
        this.playSrc = "";
        clearTimeout(this.playSrcTimer);
        this.playSrcChange = true;
        this.playSrc = val.pull;
        this.playSrcChange = false;
      }
    },
    // homeConfig: {
    //   handler(newVal){
    //     if(Object.keys(newVal).length > 0){
    //     }
    //   },
    //   immediate: true
    // }
  },
  mounted() {
    this.getData();
    this.getHot();
    this.getMatchList();

    // this.getHomeData();
  },
  beforeDestroy() {
    this.leaveRoom();
  },
  methods: {
    keepLivePull(item) {
      //点击推荐直播列表进入直播间
      if (item.is_playing !== 1) {
        this.$EventBus.$emit("hide", { type: "success", msg: "比赛已结束！" });
        return;
      }
      localStorage.setItem("pull", item.pull);
      let routeUrl = this.$router.resolve({
        path: "/liveDetails/" + item.id + "-" + item.stream,
      });
      window.open(routeUrl.href);
    },
    convertType(item) {
      if (item.type === "1") return "足球";
      if (item.type === "2") return "篮球";
      if (item.type === "3") return "电竞";
      if (item.type === "4") return "其他";
    },
    toMatchDetail(item) {
      if (item.is_playing === 0) {
        this.$EventBus.$emit("hide", { type: "success", msg: "敬请期待！" });
        return;
      }
      if (item.is_playing === 2) {
        this.$EventBus.$emit("hide", { type: "success", msg: "比赛已结束！" });
        return;
      }
      let routeUrl = this.$router.resolve({
        path: "/liveDetails/" + item.id + "-" + item.stream,
      });
      window.open(routeUrl.href);
    },
    getMatchList() {
      this.$axios
        .post("/", {
          service: "VarcharMatch.GetList",
          type: "0",
          hot_status: "0",
          rocm_status: "0",
          p: 1,
          limit: 66,
        })
        .then((res) => {
          let data = res.data.data.info[0];
          if (data.list && data.list.length > 0) {
            const nowTime = new Date().getTime();

            for (let item of data.list) {
              // item.away_icon = this.homeConfig.huawei.domain + '/' + item.away_icon
              // item.home_icon = this.homeConfig.huawei.domain + '/' + item.home_icon
              // item.thumb = this.homeConfig.huawei.domain + '/' + item.thumb
              item.user = {
                avatar_thumb: "",
              };
              item.title = `${item.name} ${item.home_team}vs${item.away_team}`;
              item.user_nicename = "比特主播";
              item.viewnum = "100091";
              item.uid = item.id;
              item.stream = "match";
              item.pull = item.view_url;
              item.sort = Number(item.sort);
              item.start_time_name = dayjs(item.start_time * 1000).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              item.livetype = "Manual";
              let _time = Number(item.start_time) * 1000;
              let _endTime = (Number(item.start_time) + 150 * 60) * 1000;

              // 未开始
              if (_time > nowTime) {
                item.statusName = "待开赛";
                item.is_playing = 0;
              } else if (_endTime > nowTime) {
                item.statusName = "直播中";
                item.is_playing = 1;
              } else if (_endTime < nowTime) {
                item.statusName = "已结束";
                item.is_playing = 2;
              }

              if (item.status === "1") {
                item.statusName = "已结束";
                item.is_playing = 2;
              }
            }
            this.RecommendData = data.list.filter(
              (item) => item.rocm_status === "1" && item.statusName === "直播中"
            );
            window.localStorage.setItem(
              "RecommendData",
              JSON.stringify(this.RecommendData)
            );
            this.liveListMore = this.liveListMore.concat(
              data.list.filter(
                (item) =>
                  item.hot_status === "1" && item.statusName === "直播中"
              )
            );

            const endData = data.list.filter(
              (item) => item.statusName === "已结束"
            );
            const noEndData = data.list.filter(
              (item) => item.statusName === "直播中"
            );
            const wartingData = data.list.filter(
              (item) => item.statusName == "待开赛"
            );
            this.HotData = [...noEndData, ...wartingData, ...endData];
          }
        });
    },
    getHomeData() {
      sportgetHomeData({}).then((res) => {
        console.log("response", res);
        if (res.code == 0) {
          let list = res.info;
          let HotData = list.filter((item) => {
            if (item.home_team && item.away_team) {
              return item;
            }
          });
          this.HotData = HotData;
        }
      });
    },
    enterLiving() {
      //统计游客或用户正在看首页的哪个直播
      // let arr = this.paramId.split('-');
      // let newStream = this.paramId.replace(arr[0] + '-','');
      this.$axios.post("/", {
        service: "PCLive.EnterRoom",
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        liveuid: this.liveUid,
        stream: this.liveStream,
      });
    },
    leaveRoom() {
      //统计游客或用户离开首页的哪个直播
      // let arr = this.paramId.split('-');
      // let newStream = this.paramId.replace(arr[0] + '-','');
      this.$axios
        .post("/", {
          service: "PCLive.LeaveRoom",
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          stream: this.liveStream,
        })
        .then((response) => {
          let res = response.data.data;
        });
    },
    lvSecret(StreamName) {
      //直播鉴权
      let timestamp = Date.parse(new Date()),
        key = "02019d98d6084be641cbf67ce3aa65fc",
        txTime = timestamp.toString(16),
        txSecret = this.md5(key + StreamName + txTime),
        liveSecret = "txSecret=" + txSecret + "&txTime=" + txTime;
      return liveSecret;
    },
    clickLiveList(index, uid, stream, item) {
      //点击首页具体直播进入直播间
      if (item.type && item.livetype === "Manual" && item.is_playing !== 1) {
        this.$EventBus.$emit("hide", { type: "success", msg: "比赛已结束！" });
        return;
      }
      this.leaveRoom();
      this.playerClickCount++;
      this.liveIndex = index;
      this.liveUid = uid;
      this.liveStream = stream;
      this.enterLiving();
    },
    getData() {
      this.$axios
        .post("/", {
          service: "PCHome.getHomeData",
        })
        .then((response) => {
          let res = response.data.data;
          if (res.code == 0) {
            this.bulletinData = res.info[0].pcNotice;
            this.$store.commit("setNotices", this.bulletinData);
            // this.HotData = res.info[0].pcMatch;
            // this.bgImg = res.info[0].backgroundImage
          }
        });
    },
    mapStatus(status) {
      // 0:未开赛 1:进行中 2:已结束 3:已延期 4:已删除
      switch (status) {
        case "0":
          return "未开赛";
        case "1":
          return "进行中";
        case "2":
          return "已结束";
        case "3":
          return "已延期";
        case "4":
          return "已删除";
        default:
          return "";
      }
    },
    getDate(timeDate) {
      let date = new Date(timeDate * 1000);
      let m = date.getMonth() + 1;
      let day = date.getDate();
      return (m < 10 ? "0" + m : m) + "-" + (day < 10 ? "0" + day : day);
    },
    goAd(item) {
      if (!item) return;
      this.clickAd(item);
      if (item.url) {
        window.open(item.url);
      }
    },
    goAnnouncement(item) {
      // this.$router.push({
      //   path: '/announcementDetails/' + item.id
      // })
      let routeUrl = this.$router.resolve({
        path: "/announcementDetails/" + item.id,
      });
      window.open(routeUrl.href);
    },
    getHot() {
      apiGetHot({ limit: 8 })
        .then((res) => {
          this.realLiveList = res.info;
          if (this.liveListMore.length > 0) {
            this.liveList = res.info.concat(this.liveListMore);
          } else {
            this.liveList = res.info;
          }
          if (this.liveList.length > 0) {
            //有直播数据的才进入
            this.liveUid = this.liveList[0].uid;
            this.liveStream = this.liveList[0].stream;
            this.enterLiving();
          }
          this.getAd();
        })
        .catch((err) => {
          this.getAd();
        });
    },
    getAd() {
      apiGetAdList().then((res) => {
        let list = res.info[1].items;
        for (let item of list) {
          if (item.id === "86") {
            let index = Math.floor(Math.random() * this.realLiveList.length);
            console.log(index);
            console.log(this.realLiveList[index]);
            item.url = `http://${window.location.host}/#/liveDetails/${this.realLiveList[index].uid}-${this.realLiveList[index].stream}`;
          }
        }
        this.adList = res.info[1].items;
        this.pcBanner = res.info[0].items[0];
        this.rightAdList = res.info[2].items;
        if (res.info[3].items.length > 0) {
          this.$EventBus.$emit("set-top-ad", res.info[3].items[0]);
        }
      });
    },
    clickAd(ad) {
      apiClickAd({ slide_items_id: ad.slide_id }).then((res) => {});
    },
  },
  filters: {
    dateFilter: (value) => {
      let arr = value.split("-");
      let date = new Date().getDate();
      return arr[1] == date ? "" : "明天";
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  overflow: hidden;
  min-width: 120rem;
}
.banner {
  padding-top: 6.3rem;
  // padding-bottom:0.5rem;
  width: 100%;
  height: 57.4rem;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  overflow: hidden;
  background-color: #131036;
  margin-bottom: 0;
  /* background: url('../assets/img/bg.jpg')no-repeat!important;
  background-size: 100% 100%!important; */
}
.banner-content {
  max-width: 120rem;
  margin: 0 auto;
  /* margin-top:1.6rem; */
  display: flex;
  /* height:42.8rem; */
  justify-content: space-between;
  border-radius: 10px;
  background-color: rgba(11, 9, 9, 0.66);
  overflow: hidden;
}
.live {
  width: 102.4rem;
  height: 57.4rem;
  background: #000;
  overflow: hidden;
}
.live-list {
  width: 17.6rem;
  // display:flex;
  // flex-direction: column;
  padding: 0.5rem 0;
  height: 57.4rem;
  overflow-y: scroll;
  overflow-x: hidden;
}
.live-list::-webkit-scrollbar {
  width: 1px;
}
.live-list:hover .live-li:after {
  display: none;
}
.living {
  width: 100%;
  height: calc(100% - 0.4rem);
  margin-top: 0.2rem;
  box-sizing: border-box;
  padding: 0 0.2rem;
}
.live-li {
  width: 16.4rem;
  margin-left: 0.5rem;
  height: 8.8rem;
  border: 0.2rem solid transparent;
  margin-top: 0.7rem;
  cursor: pointer;
  border-radius: 1rem;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
}
.live-li:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1;
}
.live-li:nth-child(1) {
  margin-top: 0;
}
.live-li img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.3rem;
  background: #eaeaea;
}
.live-li:hover {
  border: 0.2rem solid #dff7f9;
}
.live-li:hover img {
  border-radius: 0;
}
.live-li:hover .show-title {
  display: block;
  background: linear-gradient(
    0deg,
    rgba(3, 3, 3, 0.37) 69%,
    rgba(3, 3, 3, 0) 100%
  );
}
.show-title {
  // display:none;
  position: absolute;
  width: 100%;
  height: 2.8rem;
  color: #fffefe;

  line-height: 3.2rem;
  text-indent: 1rem;
  bottom: 0;
}
.living {
  position: relative;
}
.enter-studio {
  position: absolute;
  width: 22rem;
  height: 4rem;
  border: 0.1rem solid var(--primary-color);
  color: var(--primary-color);
  border-radius: 0.3rem;
  font-weight: 600;
  top: 50%;
  left: 50%;
  margin-left: -11rem;
  margin-top: 9rem;
  text-align: center;
  line-height: 4rem;
  font-size: 1.6rem;
  z-index: 11;
}
.enter-studio:hover {
  background: var(--primary-color);
  color: #fff;
}
.living-active {
  border: 0.2rem solid #d2ac84;
  position: relative;
}
.living-active:after {
  display: none;
}
/* .living-active::after{
  position:absolute;
  top:50%;
  margin-top:-0.5rem;
  left:-1.4rem;
  content:'';
  display:block;
  border-top:0.5rem solid transparent;
  border-right:1rem solid var(--primary-color);
  border-bottom:0.5rem solid transparent;
} */
.living-active img {
  border-radius: 0;
}
.game-list {
  height: 16.5rem;
  background: #000;
  overflow: hidden;
}
.game-lunbo {
  width: 120rem;
  margin: 0 auto;
  margin-top: 1.15rem;
  height: 14rem;
}
.swiper-container {
  width: 100%;
  height: 100%;
  overflow: visible;
}
.swiper-wrapper {
  width: 114.4rem;
  height: 14rem;
  overflow: hidden;
}
.swiper-slide {
  width: 22rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;
}
.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 0;
  top: 5.5rem;
  width: 2.8rem;
  height: 5.6rem;
  background: var(--img-right);
}
.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: 0;
  top: 5.5rem;
  width: 2.8rem;
  height: 5.6rem;
  background: var(--img-left);
}
.section-bottom {
  width: 120rem;
  margin: 0 auto;
}
.ad-middle {
  padding: 1.2rem 0;
  display: flex;
  height: 17.5rem;
  justify-content: space-between;
}
.ad-live {
  width: 46.4rem;
  height: 17.5rem;
  max-width: 100%;
  border-radius: 4px;
}
.ad-live >>> .el-carousel__indicators--horizontal {
  display: none;
}
.ad-bg {
  height: 100%;
  background-position: center center;
  background-size: cover;
  cursor: pointer;
}
.announcement {
  display: flex;
  flex-direction: column;
  background: #fff;
  flex: 1;
  margin: 0 1.2rem;
  padding: 0.9rem 1.8rem;
  border-radius: 4px;
}
.download-app {
  width: 24.1rem;
  height: 100%;
  border-radius: 4px;
  /* background:url('../assets/img/app-download.png') no-repeat left top; */
  /* background-size:100% auto; */
}
.announcement-icon {
  font-weight: bold;
  color: #2c2828;
}
.laba {
  color: var(--primary-color);
}
.dian {
  color: #cdcdcd;
}
.announcement-words {
  margin-top: 1.2rem;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.announcement-words:hover {
  color: var(--primary-color);
}
.words-right {
  color: #abaaaa;
}
.words-right:hover {
  color: var(--primary-color);
}
.slide-top {
  padding: 0.7rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  align-items: center;
  background: #f3f2ef;
  height: 3rem;
  font-size: 1.2rem;
}
.slide-left {
  color: #979797;
}
.slide-right {
  width: 5.1rem;
  height: 2rem;
  // background: var(--primary-color);
  text-align: center;
  line-height: 2rem;
  color: #979797;
  border-radius: 0.3rem;
}

.slide-right.match-type-0,
.slide-right.match-type-2,
.slide-right.match-type-3,
.slide-right.match-type-4 {
  background-color: #959292;
  color: #fff;
}
.slide-bottom {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  margin-top: 0.6rem;
  justify-content: space-between;
  align-items: center;
}
.type-bottom {
  height: 3rem;
  background: #f3f2ef;
  font-size: 1.2rem;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.type-bottom .playing {
  background: rgba(255, 223, 131, 0.33);
  color: #ff0707;
  width: 100%;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.unplay {
  background: F3F2EF;
  color: #000;
  width: 100%;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.type-bottom .playing img {
  width: 1.3rem;
  height: 1.5rem;
  border-radius: 0;
  border: 0;
  margin-right: 5px;
  margin-bottom: 3px;
}
.slide--bottom {
  padding: 0.6rem 0 0;
}
.slide-bottom img {
  width: 2.4rem;
  height: 2.4rem;
  object-fit: contain;
  border-radius: 50%;
  border: 1px solid #e9e9e9;
}
.league-name {
  margin-top: 0.9rem;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vs {
  color: #ff0606;
  font-size: 20px;
  font-weight: bold;
}
.socre {
  color: #ff0606;
  font-size: 1.4rem;
  display: block;
  text-align: center;
  flex: 1;
}
.words-left {
  width: 38rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.words-right {
  padding-top: 0.4rem;
}
.game-lunbo .slide-bottom:not(.matching),
// .game-lunbo .slide-bottom:not(.matching) .socre  {
//   color: #999;
// }
.game-lunbo .slide-bottom:not(.matching) .game-date {
  font-size: 1.2rem;
  color: var(--primary-color);
  display: flex;
  justify-content: center;
  width: 100%;
  color: #000;
}
.game-name {
  font-family: PingFang SC;
  color: #000;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 1.4rem;
  flex: 1;
}
.isplaying {
  color: #ff0606 !important;
}
.intro-top {
  display: flex;
}
.live-icon {
  font-size: 2.4rem;
  font-weight: bold;
}
.living-icon,
.living-management {
  color: var(--primary-color);
  font-size: 3rem;
}
.intro-bottom {
  margin-top: 1.7rem;
  background: #fff;
  padding-top: 1.2rem;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
}
.Recommend-list {
  width: 95.3rem;
}
.Recommend-list .intro-list {
  width: 22rem;
  box-shadow: 0 0 0.1rem #000;
  margin-bottom: 2.1rem;
  cursor: pointer;
  margin-left: 1.5rem;
}

.Recommend-list .introlist-top {
  width: 22rem;
  height: 12.3rem;
  overflow: hidden;
  position: relative;
}
.intro-list:hover .hover-play,
.intro-list:hover .introlist-words {
  display: block;
  color: var(--primary-color);
}
.hover-play {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
}
.hover-play span {
  width: 5rem;
  height: 5rem;
  position: absolute;
  left: 50%;
  margin-left: -2.5rem;
  top: 50%;
  margin-top: -2.5rem;
  background: url("./../assets/img/hover-play.png") center center;
  background-size: 100% 100%;
}
.introlist-top img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.introlist-bottom {
  padding: 1rem;
  display: flex;
  flex-direction: column;
}
.introlist-words {
  font-weight: bold;
  min-height: 1.4rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #2b2626;
}
.introlist-look {
  margin-top: 1.7rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.look-left,
.look-right {
  color: #949292;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.look-right {
  min-width: 7rem;
  text-align: right;
}
.look-left img {
  width: 2.7rem;
  height: 2.7rem;
  object-fit: cover;
  border-radius: 50%;
  overflow: hidden;
}
img {
  background: #eaeaea;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue